import { render, staticRenderFns } from "./TemplateClaim.vue?vue&type=template&id=64815ba0&"
import script from "./TemplateClaim.vue?vue&type=script&lang=js&"
export * from "./TemplateClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports